import { atom } from 'jotai';
import type { DocumentDataStatusFilters } from '../types/packager-types';

export const documentDataEditDialogIdAtom = atom<{
  id: string;
  documentId: string;
  currentStatus?: DocumentDataStatusFilters;
  currentExclusionReason?: string | null;
  currentEscalationDetail?: string | null;
} | null>(null);
